import { RestSlice } from 'src/redux/rest.slice';
import { IppSampleImportTranslation } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippSampleImportTranslationSlice = new RestSlice<IppSampleImportTranslation>(
	localizationService.getLocalizedString('ipp.samples.importSamples.translateData'),
	Resource.IppSampleImport + '/DataSourceTranslations'
);
export default ippSampleImportTranslationSlice.rests.reducer;
